import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DeviceList',
  templateUrl: './DeviceList.component.html',
  styleUrls: ['./DeviceList.component.scss']
})
export class DeviceListComponent implements OnInit {

  Token:String=""
  page:number=0;
  Procssing:boolean=false;
  StartSearchDate:string=''
  EndSearchDate:string=''
  SubmitPeriodDate:string='0'
  Filter_title: string = ""

  Component_Swicher:string='List'

  ActiveCount:number=0
  DisActiveCount:number=0

  modalRef_Delete: any;
  constructor(
    private Device_Service:DeviceService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private Tariff_Service:TariffService,
    private modalService: BsModalService
  ) { }


  DataList_Device:Array<Device_Interface>=[]
  Data_Seleted_Delete:Device_Interface=Empty_Device_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,18).subscribe(
      data=>{
        this.ReadData_Device_Count()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  ReadData_Device_Count(){
    this.Procssing=true

    this.Device_Service.GetDeviceCount(this.Token).subscribe(
      data=>{
        this.ActiveCount=data['active']
        this.DisActiveCount=data['disactive']
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Device(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.StartSearchDate=StartSearchDate
    this.EndSearchDate=EndSearchDate

    this.Device_Service.GetRecord(this.Filter_title,this.Token,Number(this.SubmitPeriodDate),StartSearchDate,EndSearchDate).subscribe(
      data=>{
        this.DataList_Device=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  Delete(item:Device_Interface){
    this.modalRef_Delete.hide()
    item.DeletingProccess=true
    this.Device_Service.DeleteDevice(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")

        this.ReadData_Device_Count()
        this.ReadData_Device(this.StartSearchDate,this.EndSearchDate)
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  DataList_Tariff_History:Array<Tariff_Interface>=[]
  Read_History(item:Device_Interface)
  {
    this.Data_Seleted_Delete=item
    item.DeletingProccess=true
    this.Tariff_Service.GetHistory(this.Token,item.id).subscribe(
      data=>{
        item.DeletingProccess=false
        this.Component_Swicher='History'
        this.DataList_Tariff_History=data
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Read_Environment(item: Device_Interface)
  {
    this.Data_Seleted_Delete = item
    this.Component_Swicher='Environment'
  }

  BackToList(){
    this.Component_Swicher='List'
  }


  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }


  order:string='id'
  orderreverse :boolean=true
  ChangeOrder(item:string)
  {
    this.order=item
    this.orderreverse=!this.orderreverse
  }

}
